import { type Control, useForm, useWatch } from 'react-hook-form';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Card } from '@/components/ui/card';
import { DataTable } from '@/components/ui/data-table';
import { layoutToColumns, ScreenForm } from '@/lib/screen-renderer';

/**
 * Preview real — usa o mesmo `ScreenForm` (react-hook-form) que roda em produção, dentro de um
 * form descartável. Fica dentro de um accordion fechado por padrão: sempre visível deixa a tela
 * gigante enquanto você monta o layout, então só abre quando quiser conferir o resultado.
 */
export function ScreenPreview({ control }: { control: Control<any> }) {
  const layout = useWatch({ control, name: 'layout' });
  const resource = useWatch({ control, name: 'resource' });
  const previewForm = useForm<Record<string, any>>({ defaultValues: {} });

  const columns = layoutToColumns(layout?.columns ?? [], resource ?? '');

  return (
    <Accordion type="single" collapsible className="col-span-full">
      <AccordionItem value="preview" className="rounded-[14px] border border-border px-4">
        <AccordionTrigger>Preview (listagem e formulário)</AccordionTrigger>
        <AccordionContent>
          <div className="space-y-6">
            <Card className="p-4">
              <h3 className="font-semibold mb-3">Preview da listagem</h3>
              <DataTable columns={columns} data={[]} />
            </Card>

            <Card className="p-4">
              <h3 className="font-semibold mb-3">Preview do formulário</h3>
              <ScreenForm
                fields={layout?.fields ?? []}
                control={previewForm.control}
                mode="create"
                resource={resource}
              />
            </Card>
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
